import React, { Component } from 'react';

import QuickLinksTop from './components/molecules/B13.2-quick-links-top';
import QuickLinksBottom from './components/molecules/B13.2-quick-links-bottom';

import './B13.2-quick-links-login.scss';

class B13QuickLinksLogin extends Component {
	state = {
		view: 'default',
		back: false,
	}

	onClick = (event) => {
		event.preventDefault();
	}

	render() {
		return (
			<section className="B13-quick-links-login__overlay container">
				<div className="B13-quick-links-login__content">
					<div className="B13-quick-links-login__content-inner">
						<section className="B13-quick-links-login__top">
							<div className="B13-quick-links-login__wrapper">
								<QuickLinksTop clickType="login" onClick={this.onClick} />
							</div>
						</section>
						<section className="B13-quick-links-login__bottom">
							<div className="B13-quick-links-login__wrapper">
								<QuickLinksBottom />
							</div>
						</section>
					</div>
				</div>
			</section>
		);
	}
}

export default B13QuickLinksLogin;
